import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProspectDetail from '../components/ProspectDetail';
import { useAuth } from '../context/AuthContext'; // Importez useAuth

const ProspectDetailPage = () => {
  const { id } = useParams();
  const [prospect, setProspect] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Ajoutez un état pour les erreurs
  const { user } = useAuth(); // Obtenez l'utilisateur connecté

  useEffect(() => {
    const fetchProspect = async () => {
      setLoading(true);
      setError(null); // Réinitialisez l'erreur à chaque nouvelle tentative
      try {
        // Construire l'URL de l'API avec l'ID du prospect, user_id et user_role
        let apiUrl = `https://venteclead.st-info.fr/get_prospects.php?id=${id}`;
        if (user?.id && user?.role) {
          apiUrl += `&user_id=${user.id}&user_role=${encodeURIComponent(user.role)}`;
        }

        const response = await fetch(apiUrl);
        if (!response.ok) {
          throw new Error(`Erreur du serveur: ${response.status}`);
        }
        const data = await response.json();

        if (data.error) {
          throw new Error(data.error);
        }
        // L'API get_prospects.php retourne un tableau, nous prenons le premier élément
        setProspect(data[0] || null);
      } catch (err) {
        console.error("Erreur lors du chargement du prospect:", err);
        setError('Impossible de charger les détails du prospect.');
      } finally {
        setLoading(false);
      }
    };

    if (id && user) { // Assurez-vous que l'utilisateur est chargé avant de faire la requête
      fetchProspect();
    }
  }, [id, user]); // Ajouter user comme dépendance

  const handleUpdate = async (updatedProspect) => {
    try {
      const response = await fetch('https://venteclead.st-info.fr/update_prospect.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(updatedProspect),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Réponse invalide du serveur' }));
        throw new Error(errorData.error || `Erreur HTTP ${response.status}`);
      }
      
      const result = await response.json();
      if (result.error) {
        throw new Error(result.error);
      }

      setProspect(updatedProspect); // Mettre à jour l'état local après la sauvegarde
      alert("Prospect mis à jour avec succès !");
    } catch (err) {
      console.error('Erreur lors de la mise à jour du prospect:', err);
      alert(`La mise à jour a échoué: ${err.message}`);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl text-gray-600">Chargement du prospect...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center text-red-600 bg-red-100 p-4 rounded-md mt-8">{error}</div>
    );
  }

  if (!prospect) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-xl text-gray-600">Prospect introuvable.</div>
      </div>
    );
  }

  return (
    <div>
      <ProspectDetail prospect={prospect} onUpdate={handleUpdate} />
    </div>
  );
};

export default ProspectDetailPage; 